import Blog from './Blog'
import Detail from './Detail'
export default {
  Blog, Detail
}



// WEBPACK FOOTER //
// ./src/components/Blog/index.js